import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  ref,
  watch,
} from "vue";
import type { IFieldValue } from "@/components/form/types";

// interface
interface Props {
  default?: { [key: string]: IFieldValue };
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FormGroup',
  props: {
    default: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  default?: { [key: string]: IFieldValue };
};



// computed
const isValid = computed<boolean>(() => {
  // oxlint-disable-next-line no-unused-expressions
  tick.value;

  const fields = form.value?.querySelectorAll(".field-group");

  if (!fields) return false;

  for (const field of fields) {
    const valid = field.getAttribute("data-valid");
    if (valid === "false") return false;
  }

  return true;
});

// data
const models = ref<{ [key: string]: IFieldValue }>(props.default ?? {});
const form = ref<HTMLFormElement>();
const tick = ref<number>(0);

// methods
function nextTick() {
  setTimeout(() => {
    tick.value++;
  }, 0);
}
function clear() {
  models.value = {};
}

// watch
watch(models, nextTick, { deep: true });

// expose
expose({ models, clear, nextTick, isValid });

return { __sfc: true,props, isValid, models, form, tick, nextTick, clear }
}

})